import requestWithImage from 'ui-forms-embed-components-reporting/reporting/internal/requestWithImage';
const BASE_URL = 'https://forms.hsforms.com/embed/v3';
const getBaseUrl = ({
  env,
  hublet
}) => {
  let baseUrl = BASE_URL;
  if (env === 'qa') {
    baseUrl = baseUrl.replace('hsforms.com', 'hsformsqa.com');
  }
  if (hublet) {
    baseUrl = baseUrl.replace('//forms.', `//forms-${hublet}.`);
  }
  return baseUrl;
};
const reportAnalyticCount = (key = '', count = 1, options) => void requestWithImage(`${getBaseUrl(options)}/counters.gif?key=${key}&count=${count}`);
export default reportAnalyticCount;